import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { ChannelWithDocId } from '@yoimo/client-sdk/channels';
import { EventWithDocId } from '@yoimo/client-sdk/events';
import { HeaderModule, PromotionalBlock } from '@yoimo/interfaces';
import { PageCoverModule } from '@yoimo/joymo-ui';

import { Observable } from 'rxjs';

import { PageScope, HeaderType } from 'shared-lib/core';

import { DescriptionBlockComponent } from '../block/description-block/description-block.component';
import { PromotionComponent } from '../promotions/promotion.component';
import { SocialShareComponent } from '../social-share/social-share.component';

@Component({
  standalone: true,
  selector: 'joymo-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  imports: [
    PageCoverModule,
    PromotionComponent,
    CommonModule,
    SocialShareComponent,
    DescriptionBlockComponent,
  ],
})
export class PageHeaderComponent {
  @Input() showActions = false;
  @Input() channel?: ChannelWithDocId;
  @Input() event?: EventWithDocId | null;
  @Input() headerModule?: HeaderModule;
  @Input() headerType: HeaderType = 'DEFAULT';
  @Input() pageDescription?: PageScope['pageDescription'];
  @Input() promotionalBlock$?: Observable<PromotionalBlock | undefined>;
}
